// @flow

import React from 'react'
import type { Image as ImageType } from 'types/'
import { markdown } from 'markdown'
import Container from './Container'
import Image from './Image'

type Props = {
  title: string,
  subtitle: string,
  text: string,
  color: string,
  backgroundColor: string,
  image: ImageType,
}

const Slide = ({ title, subtitle, text, image, color, backgroundColor }: Props) => {
  return (
    <div className="relative bg-bottom h-slider-mobile md:h-slider md:max-h-80vh md:bg-right-bottom bg-75 md:bg-auto-slide" style={{
      backgroundColor: `#${backgroundColor}`,
      backgroundImage: `url(${image.dir}${image.name.normal}.${image.extension})`,
      backgroundRepeat: 'no-repeat',
    }}>
      <div className="absolute inset-0 py-12 md:pt-12 md:pb-48">
        <Container className="flex flex-col items-start justify-between md:justify-start">
          <div key="text-color" className="mb-8 font-black md:mb-16" style={{ maxWidth: "1100px", color: `#${color}` }}>
            {title && 
              <h2
                className="text-2xl leading-tight md:text-4vw xl:text-5xl"
                dangerouslySetInnerHTML={{ __html: markdown.toHTML(title) }}
              />
            }
            {subtitle && 
              <h3
                className="mt-4 text-xl leading-tight md:text-2.6vw xl:text-2xl"
                dangerouslySetInnerHTML={{ __html: markdown.toHTML(subtitle) }}
                />
            }
          </div>
          <div key="text-black" className="font-black text-black">
            {text && 
              <h4
                className="text-xl leading-tight md:text-2.6vw xl:text-2xl"
                dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }}
              />
            }
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Slide
